import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import {HashRouter as Router} from 'react-router-dom';

import {Provider} from 'react-redux';
import {setupStore} from 'redux/store';

const container = document.getElementById('root');
const root = createRoot(container);
const store = setupStore({});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
);
